import config from '../data/siteSeo.json';
import { sharingMetadata, siteGraph, serializeSchema } from './seo-shared.mjs';

export function applyPageMetadata(locale, meta, canonical, type = 'website') {
    document.documentElement.lang = locale;
    document.title = meta.title;
    const sharing = sharingMetadata(config, locale, meta, canonical, type);
    for (const [attribute, values] of [['name', sharing.named], ['property', sharing.property]]) {
        for (const [key, value] of Object.entries(values)) {
            let node = document.head.querySelector(`meta[${attribute}="${key}"]`);
            if (!node) {
                node = document.createElement('meta');
                node.setAttribute(attribute, key);
                document.head.appendChild(node);
            }
            node.content = value;
        }
    }
    let schema = document.getElementById('site-structured-data');
    if (!schema) {
        schema = document.createElement('script');
        schema.id = 'site-structured-data';
        schema.type = 'application/ld+json';
        document.head.appendChild(schema);
    }
    schema.textContent = serializeSchema(siteGraph(config, locale, meta, canonical));
}
